var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#B46C9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4291_21529",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4291_21529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 21.9995V19.9995H20.6663V21.9995H7.33301ZM9.99967 16.9419H10.824L16.3573 11.4187L15.9382 10.9932L15.5228 10.5842L9.99967 16.1175V16.9419ZM8.99967 17.9419V15.6919L16.4728 8.22905C16.5694 8.13249 16.679 8.05944 16.8017 8.00988C16.9242 7.96033 17.0518 7.93555 17.1843 7.93555C17.317 7.93555 17.4455 7.96033 17.5697 8.00988C17.6939 8.05944 17.8077 8.13594 17.9112 8.23938L18.7125 9.05088C18.816 9.14744 18.8907 9.25805 18.9368 9.38271C18.983 9.50727 19.006 9.63605 19.006 9.76905C19.006 9.89371 18.9826 10.0177 18.9358 10.1409C18.8891 10.2642 18.8146 10.3769 18.7125 10.479L11.2497 17.9419H8.99967ZM16.3573 11.4187L15.9382 10.9932L15.5228 10.5842L16.3573 11.4187Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconPink);
export default __webpack_public_path__ + "static/media/EditIconPink.d9d8f5ed563f1cdb6530ad825488c22c.svg";
export { ForwardRef as ReactComponent };